module.exports = __webpack_public_path__ + "img/typolibris-service.4876d118.png";